import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { IntegrationFormState } from "../../types";

interface McpFormProps {
  formData: IntegrationFormState;
  setFormData: (data: IntegrationFormState) => void;
}

const McpForm = ({ formData, setFormData }: McpFormProps) => {
  return (
    <div>
      <Label className="text-sm font-semibold">MCP Server URL *</Label>
      <Input
        type="text"
        placeholder="e.g., https://mcp-server.example.com"
        value={formData.server_url || ""}
        onChange={(e) => setFormData({ ...formData, server_url: e.target.value })}
        className="mt-2"
      />
    </div>
  );
};

export default McpForm;
